'use client'
import { getTranslation } from "@/i18n/get-translation";
import Link from "next/link";
import { usePathname } from "next/navigation";

interface INavigation {
  name: string;
  href: string;
}

const navigation: INavigation[] = [
  { name: "blog", href: "/blog" },
  { name: "news", href: "/news" },
  { name: "contact", href: "/contact-us" },
];
interface IBlogCategories {
  locale: string;
}
export default function SubCategories({ locale }: IBlogCategories) {
  const t = getTranslation(locale, "blogs");
  const tt = getTranslation(locale, "blogsCategories");
  const pathname = usePathname();
  return (
    <div className="border-t border-b-[0.1875rem] border-b-primary-500 border-t-primary-200 w-full md:flex hidden justify-center px-20 max-md:px-7 mt-20 md:py-5 py-4 relative">
      <div className="md:block hidden mr-auto absolute lg:left-20 left-7">
        <Link
          href="/"
          className="flex justify-center items-center xl:text-xl lg:text-lg text-base font-medium text-primary-800 hover:text-primary-700"
        >
          {t("backToHome")}
        </Link>
      </div>
      <div className="flex text-primary-800 md:flex-auto md:w-auto w-full md:justify-end lg:justify-center justify-between items-center xl:gap-[3rem] lg:gap-[2.5rem] md:gap-[2rem] sm:gap-[1.5rem] gap-3">
        {navigation.map((item: INavigation) => (
          <Link
            key={item.name}
            href={`/${locale}${item.href}`}
            className={`hover:text-primary-700 xl:text-xl lg:text-lg text-base font-medium ${
              pathname.includes(item.name) ? "text-primary-700" : ""
            }`}
          >
            {tt(item.name)}
          </Link>
        ))}
      </div>
    </div>
  );
}
